module.exports = function() {
  return new Worker(__webpack_public_path__ + "2a18138d6a188f708d56.worker.js");
};